import { render, staticRenderFns } from "./BuyTimeModal.vue?vue&type=template&id=eed68006&scoped=true"
import script from "./BuyTimeModal.vue?vue&type=script&lang=js"
export * from "./BuyTimeModal.vue?vue&type=script&lang=js"
import style0 from "./BuyTimeModal.vue?vue&type=style&index=0&id=eed68006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed68006",
  null
  
)

export default component.exports